<template>
  <div class="md-layout">
    <!-- 折线图-数据变化 -->
    <template>
      <!-- 标题 -->
      <label class="md-layout-item md-size-30 md-xsmall-size-100" :style="{'padding': '0 12px 0 30px','line-height':'63px'}">
        <span :style="{'font-size': '16px', 'font-weight':'bold'}">{{$I18n("dev_flow")}}</span>
      </label>
      <!-- 类型选择 [新增用户/活跃用户/累计用户] -->
      <div class="md-layout-item md-size-100 title"  :style="{'padding': '0 12px 0 30px','margin-top':'0px','margin-bottom':'20px'}">
        <div @click="line_type = 'create'" class="change" :class="{'selected_change': line_type=='create'}">{{$I18n("new_people")}}</div>
        <div @click="line_type = 'update'" class="change" :class="{'selected_change': line_type=='update'}">{{$I18n("log_people")}}</div>
        <div @click="line_type = 'total'" class="change" :class="{'selected_change': line_type=='total'}">{{$I18n("total_people")}}</div>
      </div>
      <!-- 折线图图表 -->
      <div class="md-layout-item md-size-100" id="line_chart" :style="chartsStyle"></div>
    </template>
    <!-- 柱状图-Top10国家/地区 -->
    <template>
      <!-- 标题 -->
      <label class="md-layout-item md-size-30 md-xsmall-size-100" :style="{'padding': '0 12px 0 30px','line-height':'63px'}">
        <span :style="{'font-size': '16px', 'font-weight':'bold'}">{{$I18n("top_ten_zone")}}</span>
      </label>
      <!-- 类型选择 [新增用户/活跃用户/累计用户] -->
      <div class="md-layout-item md-size-100 title"  :style="{'padding': '0 12px 0 30px','margin-top':'0px','margin-bottom':'20px'}">
        <div @click="bar_type = 'create'" class="change" :class="{'selected_change': bar_type=='create'}">{{$I18n("new_people")}}</div>
        <div @click="bar_type = 'update'" class="change" :class="{'selected_change': bar_type=='update'}">{{$I18n("log_people")}}</div>
        <div @click="bar_type = 'total'" class="change" :class="{'selected_change': bar_type=='total'}">{{$I18n("total_people")}}</div>
      </div>
      <!-- 柱状图图表 -->
      <div class="md-layout-item md-size-100" id="bar_chart" :style="chartsStyle"></div>
    </template>
  </div>
</template>
<script>
import * as echarts from "echarts";
import { nDaysAgo, timestampToString1000 } from "@/common/tools.js";

export default {
  props: {
    app_id : {
      type: String,
      default: "",
    },
 },
  data() {
    return {
      chartsStyle : { // 用来调整 图表的 样式 的
        height : '100px',
        width: "100%",
      },
      line_type  : "create", // 折线图-显示的数据类型 {create: 新增用户, update:活跃用户, total:累计用户}
      line_date  : [         // 折线图-获取的数据的日期范围
        nDaysAgo(7), 
        nDaysAgo(1)
      ], 
      line_data  : {         // 折线图-图表插件所需的数据 
        create : {
          axis : [],
          series : []
        },
        update : {
          axis : [],
          series : []
        },
        total  : {
          axis : [],
          series : []
        },
      },
      lineCharts  : {},      // 折线图-图表插件生成的对应实体

      bar_type   : "create",    // 柱状图-显示的数据类型 {create: 新增用户, update:活跃用户, total:累计用户}
      bar_date   : nDaysAgo(1), // 柱状图-获取数据的日期
      bar_data   : {            // 柱状图-图表插件所需的数据
        create : {
          axis : [],
          series : []
        },
        update : {
          axis : [],
          series : []
        },
        total : {
          axis : [],
          series : []
        },
      },
      barCharts   : {},         // 柱状图-图表插件生成的对应实体
    }
  },
  created (){ 
    // 图表大小自适应
    this.getHeight();
    window.addEventListener('resize', this.getHeight);
  },
  mounted: function(){
    // 图表绑定DOM
    this.lineCharts = echarts.init(document.getElementById('line_chart'));
    this.barCharts  = echarts.init(document.getElementById('bar_chart'));
    
    // 数据初始化
    this.api_getBar()
      .then(this.api_getLine)
      .then(() => {
        this.charts_buildBar ();
        this.charts_buildLine();
        this.getHeight();
      })
  },
  methods:{
    get10 (barDataJSON) { // 筛选前 10 的数据
      let arrayLength = 10;
      let res = {
        axis  : [],
        series: [],
      }
      for(let key in barDataJSON) { // 插入排序 (由高到低排)
        if (res.series.length == 0 ) {
          res.axis = [this.$I18n(key? key :"unknow")]
          res.series = [barDataJSON[key]]
        } else {
          for(let i = 0; i < res.series.length ; i ++) {
            if (res.series[i] < barDataJSON[key]) {
              res.axis.splice(i,0, this.$I18n(key? key :"unknow"))
              res.series.splice(i,0, barDataJSON[key])
              break
            }
          }
          // 只保留前 {arrayLength} 位
          if (res.series.length < arrayLength && res.axis.indexOf(this.$I18n(key)) == -1) { 
            res.axis.push(this.$I18n(key? key :"unknow"))
            res.series.push(barDataJSON[key])
          } else if (res.series.length > arrayLength) {
            res.axis = res.axis.splice(0,arrayLength)
            res.series = res.series.splice(0,arrayLength)
          }
        }
      }
      // 因为图表显示问题,所以要倒叙
      return {
        axis   : res.axis.reverse(), 
        series : res.series.reverse(),
      }
    },
    getHeight(){
      this.chartsStyle.height= (window.innerHeight-400)  +'px';
      setTimeout(()=>{
        if(this.barCharts.resize){
          setTimeout(this.barCharts.resize,0);
        }
        if(this.lineCharts.resize){
          setTimeout(this.lineCharts.resize,0);
        }
      },700)
    },
    api_getLine(){ // API-获取折线图的数据 (并整理)
      return this.$api.getClientStatis({ // api: /ana/user/client/statistics
        gmt_start  : new Date(this.line_date[0]+" 00:00:00").getTime()/1000 ,
        gmt_end    : new Date(this.line_date[1]+" 23:59:59").getTime()/1000 ,
        link_id    : this.app_id,
        link_type  : 2,
      })
        .then(this.$Then(res => {
          res.data = res.data.map(i => {
            return {
              ...i,
              create_time: timestampToString1000(i.gmt_create),
            }
          })
          var d_range = (new Date(this.line_date[1]) - new Date(this.line_date[0])) / (1000 *3600 *24) + 1
          var d_now = (new Date(this.line_date[1]) - new Date(nDaysAgo(0))) / (1000 * 3600 *24) + 1
          this.line_data = {
            create : {
              axis : [],
              series : []
            },
            update : {
              axis : [],
              series : []
            },
            total  : {
              axis : [],
              series : []
            },
          }
          for(var i =0; i < d_range ; i++){
            this.line_data.create.axis.push(nDaysAgo(d_range -i -d_now))
            this.line_data.update.axis.push(nDaysAgo(d_range -i -d_now))
            this.line_data.total.axis.push(nDaysAgo(d_range -i -d_now))

            var itemData = res.data.filter(item => item.create_time.split(" ")[0] == nDaysAgo(d_range-i - d_now))
            if (itemData.length == 0) {
              this.line_data.create.series.push({all:0,ios:0,android:0,})
              this.line_data.update.series.push({all:0,ios:0,android:0,})
              this.line_data.total.series.push({all:0,ios:0,android:0,})
            } else {
              this.line_data.create.series.push({
                all: itemData[0].create_count ?itemData[0].create_count:0,
                ios: (itemData[0].create_client && itemData[0].create_client.ios) ?itemData[0].create_client.ios :0,
                android: (itemData[0].create_client && itemData[0].create_client.android) ?itemData[0].create_client.android :0,
              })
              this.line_data.update.series.push({
                all: itemData[0].update_count ?itemData[0].update_count:0,
                ios: (itemData[0].update_client && itemData[0].update_client.ios) ?itemData[0].update_client.ios :0,
                android: (itemData[0].update_client && itemData[0].update_client.android) ?itemData[0].update_client.android :0,
              })
              this.line_data.total.series.push({
                all: itemData[0].total_count  ?itemData[0].total_count :0,
                ios: (itemData[0].total_client && itemData[0].total_client.ios) ?itemData[0].total_client.ios :0,
                android: (itemData[0].total_client && itemData[0].total_client.android) ?itemData[0].total_client.android :0,
              })
            }
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.line_data = {
            create : {
              axis : [],
              series : []
            },
            update : {
              axis : [],
              series : []
            },
            total  : {
              axis : [],
              series : []
            },
          }
        }))
    },
    api_getBar(){ // API-获取柱状图的数据 (并整理)
      return  this.$api.getClientStatis({ // api: /ana/user/client/statistics
        gmt_start  : new Date(this.bar_date+" 00:00:00").getTime()/1000 ,
        gmt_end    : new Date(this.bar_date+" 23:59:59").getTime()/1000 ,
        link_id    : this.app_id,
        link_type  : 2,
      })
        .then(this.$Then(res => {
          this.bar_data = {
            create : {
              axis : [],
              series : []
            },
            update : {
              axis : [],
              series : []
            },
            total : {
              axis : [],
              series : []
            },
          }
          var barItem = res.data;
          if(barItem.length != 0) {
            if (barItem[0].create_zone != ""){
              this.bar_data.create = {...this.get10(barItem[0].create_zone)}
            }
            if (barItem[0].update_zone != "") {
              this.bar_data.update = {...this.get10(barItem[0].update_zone)}
            }
            if (barItem[0].total_zone != "") {
              this.bar_data.total  = {...this.get10(barItem[0].total_zone)}
            }
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.bar_data = {
            create : {
              axis : [],
              series : []
            },
            update : {
              axis : [],
              series : []
            },
            total : {
              axis : [],
              series : []
            },
          }
        }))
    },
    charts_buildLine(){ // 图表-构建折线图
      this.lineCharts.clear  && this.lineCharts.clear()
      this.lineCharts.resize && this.lineCharts.resize()
      this.barCharts.resize  && this.barCharts.resize()
      this.lineCharts.setOption({
        grid: {    // 偏移
          top: 10,
          left: 50,
          right: 50,
        },
        tooltip: { // 图标类型 坐标轴相关
          trigger: 'axis',
          textStyle:{
            align:"left"
          },
          axisPointer: {    // 坐标轴指示器，坐标轴触发有效
            type: 'shadow'  // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {   // X坐标轴
          type: 'category',
          data: this.line_data[this.line_type].axis,
          axisLine:{
            lineStyle:{
              color: "#888888",
            }
          },
          axisTick: {
            lineStyle:{
              color: "#dedede",
            }
          },
        },
        yAxis: {   // Y坐标轴
          type: 'value',
          axisLine:{
            show: false,
          },
          axisTick: {
            show : false,
          },
          splitLine: {
            show: true,
            lineStyle:{
              type:"dashed"
            }
          },
          // show : true,
          splitArea: 7
        },
        series: [{ // 数据
          name: "APP",
          data: this.line_data[this.line_type].series.map(i => i.all ?i.all :0),
          type: 'line',
          color: "#00bcd4"
        },{ // 数据
          name: "iOS",
          data: this.line_data[this.line_type].series.map(i => i.ios ?i.ios :0),
          type: 'line',
          color: "#f44336"
        },{ // 数据
          name: "android",
          data: this.line_data[this.line_type].series.map(i => i.android ?i.android :0),
          type: 'line',
          color: "#4caf50"
        },]
      })
    },
    charts_buildBar(){ // 图表-构建柱状图
      this.lineCharts.clear  && this.barCharts.clear()
      this.lineCharts.resize && this.lineCharts.resize()
      this.barCharts.resize  && this.barCharts.resize()
      this.barCharts.setOption({
        grid: {    // 偏移
          top: 10,
          left: 50,
          right: 50,
        },
        tooltip: { // 图标类型 坐标轴相关
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        xAxis: {   // X坐标轴
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLine:{
            show: false,
          },
          axisTick: {
            show : false,
          },
          splitLine: {
            show: true,
            lineStyle:{
              type:"dashed"
            }
          },
          // show : true,
          splitArea: 7
        },
        yAxis: {   // Y坐标轴
          type: 'category',
          data: this.bar_data[this.bar_type].axis,
          axisLine:{
            lineStyle:{
              color: "#888888",
            }
          },
          axisTick: {
            lineStyle:{
              color: "#dedede",
            }
          },
        },
        series: [{ // 数据
          type: "bar",
          barMaxWidth : 20,
          color: "#00bcd4",
          data: this.bar_data[this.bar_type].series
        }]
      })
    },
  },
  watch:{
    line_type(){
      this.charts_buildLine()
    },
    bar_type(){
      this.charts_buildBar()
    },
  },
}
</script>